import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setHackleClientAction,
  clearHackleClientAction,
} from "../redux/hacklecClient";
import { useVariationDetail } from "@hackler/react-sdk";
import { useTranslation } from "react-i18next";
import HACKLE_DATA from "../constant/HACKLE_DATA";
import _ from "lodash";
import { useTrack } from "@hackler/react-sdk";
import { TYPE } from "../constant";

function useHackleInfo() {
  const dispatch = useDispatch();
  const info = useSelector((state) => state.hackleClient); // hackle info
  const userInfo = useSelector((state) => state.user.info); // user info
  const deviceInfo = useSelector((state) => state.deviceInfo); // device info
  const { i18n } = useTranslation();
  const [hackleObj, setHackleObj] = useState({
    viewPath: "",
    key: 1,
    variation_d: "",
    isShowHackle: false,
  });
  const decision = useVariationDetail(hackleObj?.key || 1);
  const track = useTrack();

  useEffect(() => {
    const channelCode = localStorage.getItem("channel.code");

    dispatch(
      setHackleClientAction({
        [hackleObj.viewPath]: {
          variation: decision.variation,
          variation_d: hackleObj.variation_d,
          resason: decision.reason,
          key: hackleObj.key,
          channelCode: userInfo?.entryType,
          deviceType: deviceInfo?.type,
          language: i18n.language,
          isShowHackle:
            hackleObj.key ===
              HACKLE_DATA.VIEW[`${hackleObj.viewPath}`]?.["key"] &&
            channelCode === TYPE.CHANNEL.GLOBAL01 &&
            hackleObj.isShowHackle,
        },
      })
    );
  }, [hackleObj]);

  const setHackleInfo = useCallback((data) => {
    if (_.isEmpty(HACKLE_DATA.VIEW[`${data?.viewPath}`])) {
      dispatch(clearHackleClientAction());
      return false;
    }

    const { key, variation_d } = HACKLE_DATA.VIEW[`${data?.viewPath}`];

    setHackleObj({
      viewPath: data.viewPath,
      key,
      variation_d,
      isShowHackle: data.isShowHackle,
    });
  }, []);

  const clearHackleInfo = useCallback((data) => {
    dispatch(clearHackleClientAction(data?.viewPath));
  }, []);

  const setHackleLog = useCallback((eventType) => {
    const hacleEventData = { ...HACKLE_DATA.EVENT_INFO[eventType] };

    // 정의된 데이터 없을경우
    if (_.isEmpty(hacleEventData)) return;

    const { key, value, properties } = hacleEventData;
    let event = { key };

    // 정의된 value, properties 가 있는경우
    if (!_.isNull(value)) event["value"] = value;
    if (!_.isEmpty(properties)) event["properties"] = properties;

    track(event);

    if (
      process.env.REACT_APP_ENV === "development" ||
      process.env.REACT_APP_ENV === "local"
    ) {
      console.log("##### hackle event data: ", event);
    }
  }, []);

  useEffect(() => {
    // TEST LOG
    if (
      process.env.REACT_APP_ENV === "development" ||
      process.env.REACT_APP_ENV === "local"
    ) {
      // console.log("hackleInfo : ", info);
    }
  }, [info]);

  return { info, setHackleInfo, clearHackleInfo, setHackleLog };
}

export default useHackleInfo;
